import { methodResult, post } from "./api.js";
import { config, labels } from "./config.js";
import { setBusy, showFieldError, showNotice } from "./components.js";

export function initResetPassword() {
	const form = document.querySelector("[data-auth-reset-form]");
	if (!form) return;
	const currentPassword = form.elements.old_password;
	const newPassword = form.elements.new_password;
	const confirmPassword = form.elements.confirm_password;
	const resetKey = new URLSearchParams(location.search).get("key") || "";

	form.addEventListener("submit", async (event) => {
		event.preventDefault();
		showNotice(form, "");
		if (!resetKey && !currentPassword?.value) {
			showFieldError(currentPassword, labels.currentPasswordRequired);
			return;
		}
		if (!newPassword.value) {
			showFieldError(newPassword, labels.passwordRequired);
			return;
		}
		if (newPassword.value.length < config.passwordPolicy.minimum_length) {
			showFieldError(newPassword, labels.passwordTooShort);
			return;
		}
		if (!confirmPassword.value) {
			showFieldError(confirmPassword, labels.confirmPasswordRequired);
			return;
		}
		if (newPassword.value !== confirmPassword.value) {
			showFieldError(confirmPassword, labels.passwordMismatch);
			return;
		}
		if (currentPassword?.value === newPassword.value) {
			showFieldError(newPassword, labels.passwordUnchanged);
			return;
		}

		setBusy(form, true, labels.settingPassword);
		try {
			const payload = await post(
				"/api/method/frappe.core.doctype.user.user.update_password",
				{
					key: resetKey,
					old_password: currentPassword?.value || "",
					new_password: newPassword.value,
					logout_all_sessions: 1,
				},
			);
			showNotice(form, labels.passwordSet, "success");
			location.assign(methodResult(payload) || config.routes?.login || "/login");
		} catch (error) {
			showNotice(
				form,
				error.status === 410
					? labels.invalidResetLink
					: error.message || labels.requestFailed,
			);
		} finally {
			setBusy(form, false, labels.settingPassword);
		}
	});
}
